export class AssessmentAnswerSubmissionModel {
    questionanswerobject:Array<any>;
    isdraft: boolean;
    moduleID: number;

}
export class ModuleAssessmentBatchDate{
  name: string;
  classTitle: string;
  classPosition: number;
  batchID: number;
  moduleID: number;
  classID: number;
  assessmentID: number;
  id: number;
  startTime: any;
  stopTime: any;
  editable:boolean;
}

export class ModuleAssessmentDateUpdate{
  batchID: number;
  moduleID: number;
  classID: number;
  assessmentID: number;
  id: number;
  name:string;
  startTime: Date;
  stopTime: Date;
}
